export const config = {
    API_DOMAIN:"https://ecawebstage.uaenorth.cloudapp.azure.com/wp-json/wp",
    NOT_FOUND_REDIRECT_LINK: "/get-in-touch/",
    ITEMS_PER_GROUP: 12,
    URL_SEPARATOR: '*%%SEPARATOR%%*'
}
